export const regexPatterns ={
    onlyLetters: /^[a-zA-Z\s]*$/,
    onlyNumbers : /^[0-9]*$/,
    alphanumeric: /^[a-zA-Z0-9]*$/,
    noSpecialChars: /^[a-zA-Z0-9\s.,\-#]*$/,
    email : /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
}